import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import { StoreProvider } from './app/providers/StoreProvider';

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Failed to find root element');
}

createRoot(rootElement).render(
    <StrictMode>
        <StoreProvider>
            <App />
        </StoreProvider>
    </StrictMode>
);
